import { Metamodel } from 'app/model/base/model';
import { type DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { type DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { Owned } from 'app/model/base/named';
import { DataFlowDSLAdapterRegistry } from 'shell-models-lib';
import { CosmosMongoSettings } from 'app/model/dataflow/dataset-settings/cosmos-mongo-settings';
import { CosmosSqlAdapter } from './cosmos-sql.adapter';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(CosmosMongoSettings)
})
export class CosmosMongoAdapter extends CosmosSqlAdapter {
    protected _generateSetting(owner: DataFlowSource | DataFlowSink): CosmosMongoSettings {
        const result = Owned.create<CosmosMongoSettings>(CosmosMongoSettings.MODEL, owner);
        result.initialize(undefined);
        return result;
    }
}
